import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import API from '../utils/api';

export default function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await API.post('/auth/login', form);
      login(res.data.token, res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'خطأ في الاتصال بالخادم');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-icon">🌸</div>
          <h1>Jasmine Perfumes</h1>
          <p>نظام إدارة العملاء والمبيعات</p>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-2">
            <label>اسم المستخدم</label>
            <input
              value={form.username}
              onChange={e => setForm({ ...form, username: e.target.value })}
              placeholder="أدخل اسم المستخدم"
              autoComplete="username"
              required
            />
          </div>
          <div className="form-group mb-3">
            <label>كلمة المرور</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              placeholder="أدخل كلمة المرور"
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={loading}>
            {loading ? <><span className="spinner" style={{width:18,height:18}}></span> جاري الدخول...</> : 'تسجيل الدخول'}
          </button>
        </form>
      </div>
    </div>
  );
}
